import React from 'react';
import PublicPageWrapper from '../../components/PublicPageWrapper';
import { BookOpen, FlaskConical, Globe, Calculator, Microscope, Palette } from 'lucide-react';

const subjects = [
  { icon: Calculator, name: 'Mathematics', desc: 'From foundational numeracy through O-Level and A-Level mathematics.' },
  { icon: BookOpen, name: 'Languages', desc: 'English and Shona with literature and communication skills.' },
  { icon: FlaskConical, name: 'Sciences', desc: 'Physics, Chemistry, Biology with Cambridge-aligned practical work.' },
  { icon: Globe, name: 'Humanities', desc: 'History, Geography, Religious & Moral Education, and Heritage Studies.' },
  { icon: Microscope, name: 'STEM & Computing', desc: 'Computer Science, ICT, and engineering design thinking.' },
  { icon: Palette, name: 'Creative & Practical Arts', desc: 'Visual arts, music, traditional and modern dance.' },
];

export default function AcademicsPage() {
  return (
    <PublicPageWrapper title="Academics" subtitle="Following the Cambridge International curriculum for holistic, globally recognised education.">
      <div data-testid="academics-page">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {subjects.map(s => (
            <div key={s.name} className="bg-white rounded-xl border border-slate-100 p-6 hover:shadow-md hover:border-[#E8A830]/30 transition-all">
              <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center mb-4"><s.icon className="w-5 h-5 text-[#E8A830]" /></div>
              <h3 className="font-bold text-[#1B2A4A] mb-2">{s.name}</h3>
              <p className="text-sm text-slate-500">{s.desc}</p>
            </div>
          ))}
        </div>
        <div className="bg-slate-50 rounded-2xl p-8">
          <h2 className="text-lg font-bold text-[#1B2A4A] mb-5">Assessment & Examinations</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div><h3 className="font-bold text-[#E8A830] mb-2">Continuous Assessment</h3><p className="text-sm text-slate-600">Regular tests, projects, and practicals throughout each term aligned with Cambridge standards.</p></div>
            <div><h3 className="font-bold text-[#E8A830] mb-2">Cambridge IGCSE</h3><p className="text-sm text-slate-600">Form 4 students sit for Cambridge International General Certificate of Secondary Education examinations.</p></div>
            <div><h3 className="font-bold text-[#E8A830] mb-2">Cambridge A-Level</h3><p className="text-sm text-slate-600">Form 5 students pursue Cambridge Advanced Level qualifications for university entrance worldwide.</p></div>
          </div>
        </div>
      </div>
    </PublicPageWrapper>
  );
}
